import { render, staticRenderFns } from "./WithdrawQues.vue?vue&type=template&id=1d0d35b4&scoped=true&"
import script from "./WithdrawQues.vue?vue&type=script&lang=js&"
export * from "./WithdrawQues.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawQues.vue?vue&type=style&index=0&id=1d0d35b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d35b4",
  null
  
)

export default component.exports